<template>
  <textarea
    class="input-textarea"
    :class="{ 'input-textarea_error': error }"
    @input="handleInput"
    :rows="rows"
    v-model.trim="fieldValue"
    novalidate
  ></textarea>
</template>

<script>
export default {
  name: 'InputTextarea',
  props: {
    value: {
      required: false,
      default: ''
    },
    error: {
      required: false,
      type: Boolean,
      default: false
    },
    rows: {
      required: false,
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      fieldValue: this.value
    }
  },
  watch: {
    value(newValue) {
      this.fieldValue = newValue
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.input-textarea {
  @include fonts.mo-reg;
  resize: none;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: none;
  box-shadow: none;
  -webkit-appearance: none;
  &_error {
    border: 1px solid colors.$redff;
  }
}
</style>